<template>
  <div>
    <el-dialog
        :visible.sync="topUpTipDialogVisible"
        width="345px"
        class="topUpTipDialog"
        height="304px">
      <div style="text-align: center">
        <img style="margin-top: 26px" src="../../assets/img/rebate/pic_pc.svg" alt="">
        <div style="margin-top: 30px">{{ $t('top_up.transaction_account') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button  style="width: 100%;background: #AB54DB;color: #FFFFFF"  @click="handleClickTip">{{ $t('top_up.i_see') }}</el-button>
      </span>
    </el-dialog>


    <el-dialog
        :visible.sync="topUpDialogVisible"
        width="510px"
        :title="$t('member.top_up')"
		@close="btnCancel"
        class="topUpDialog chongzhi"
        height="304px">
      <div class="topUp">
        <div class="topUp_top" style="margin-top: 50px">
          <span style="display: inline-block;font-size: 14px;color: #030229;vertical-align: middle; width: 16%;">{{ $t('top_up.arrival_accounts') }}：</span>
          <span style="display: inline-block; font-size: 16px; vertical-align: middle;color: #030229">{{$t('top_up.funding_accounts')}}</span>
        </div>
        <div class="topUp_top" style="margin-top: 30px;position: relative">
          <span style="display:inline-block; font-size: 14px; width: 16%;color: #1E2329">{{$t('top_up.recharge_amount')}}：</span>
          <el-input class="input_money" style="" :placeholder="$t('top_up.please_enter_recharge_amount')" v-model="rechargeAmount" @input="checkInput" placeholder-style="color:rgba(3, 2, 41, 0.2); font-size: 14px" />
          <span style="color: #030229; font-size: 16px; position: absolute; right: 16px; top: 50%; transform: translate(0, -43%)">USDT</span>
        </div>


        <div class="topUp_top" style="margin-top: 36px; display: flex; align-items: center">
          <span style="display:inline-block; font-size: 14px; width: 16%;color: #1E2329">{{$t('top_up.payment_method')}}：</span>
		   <!-- <div class="uni-select">
			   <div style="color: rgb(3, 2, 41);font-size: 16px;cursor: pointer;" @click="toggleSelector">{{current}}</div>
			   <div class="uni-select__selector" style="display: flex;flex-direction: column;" v-if="showSelector">
			   	<div style="padding: 1px 1px; border-radius: 10px;" v-for="(item, index) in methodList" :key="index" @click="change(item)">
			   	<div style="background: #FEFEFE; height: 40px;display: flex; border-radius: 10px; align-items: center; position: relative; cursor: pointer">
						<img :src="item.chain_icon" alt="" style="display: inline-block; width: 26px; height: 26px" />
			   			<span style="display: inline-block; color: #030229; font-size: 16px; margin-left: 6px">{{item.chain_detail}}</span>
			   			<el-image v-if="item.isSelect" style="width: 33px; height: 33px; position: absolute; right: 0; top: 0" :src="require('../../assets/img/rebate/assets_select.png')"></el-image>
			   	</div>
			   	</div>
			   </div>
		   </div> -->

      <el-select v-model="current" :placeholder="$t('transfer.please_select')" @change="handleMethodChange">
      <el-option
      v-for="(item,index) in methodList"
      :key="index"
      :label="item.chain_detail"
      :value="item.chain_detail"
      style="height:45px;line-height: 45px;"
      >
      
      <img :src="item.chain_icon" alt="" style="width:26px;height:26px;vertical-align: middle;">
      <span style="margin-left:5px">{{item.chain_detail}}</span>
    </el-option>
  </el-select>
	
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="close-color" style="width: 20%; margin-top: 50px; border: 1px #EFEFFF solid; border-radius: 10px;background: unset"  @click="btnCancel">{{$t('detail_param.close')}}</el-button>
        <el-button type="primary" style="background: linear-gradient(131.47deg, #FC5D9F -37.41%, #5863FC 111.11%); width: 20%; margin-top: 50px; border-radius: 10px; margin-left: 20px;margin-right: 10px"  @click="toRecharge()">{{$t('top_up.go_to_recharge')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
        :visible.sync="toRechargeDialog"
        width="510px"
        :title="$t('top_up.confirm_recharge')"
        class="topUpDialog chongzhi"
        height="304px">
      <div class="topUp">
        <div class="topUp_top" style="margin-top: 30px">
          <span style="display:inline-block; font-size: 20px; font-weight: 700; color: #030229">{{$t('top_up.recharge_amount')}}：</span>
          <span style="display:inline-block; font-size: 20px; font-weight: 700; color: #DC4D4D">{{ confirmMoney }} USDT</span>
        </div>
        <div class="topUp_top" style="margin-top: 40px; display: flex; flex-direction: column; align-items: center">
          <span style="display:block; color: #030229; font-size: 16px">{{$t('top_up.to_copy_address')}}：</span>
          <span style="display:block; color: #5C96FF; font-size: 16px; margin-top: 10px; cursor: pointer;" @click="copyText(address)">{{address}}</span>
          <div v-if="!qrCodeUrl" style="width: 110px; height: 110px; display: flex; justify-content: center; align-items: center; margin-top: 12px">
            <span style="font-size: 12px; color: #b4bccc">loading...</span>
          </div>
          <img v-else style="display: block; width: 110px; height: 110px;margin-top: 12px" :src="qrCodeUrl">
          <span style="display: block; font-size: 14px; margin-top: 6px; width: 60%;text-align: center">{{ $t('top_up.please_be_sure_to') }}<span style="display: inline-block; color: #DC4D4D; font-size: 16px; margin: 0 10px;"> {{ timeOut }} </span>{{ $t('top_up.please_regenerate_recharge_order') }}</span>
        </div>
        <div style="padding: 0 20px; margin-top: 50px; color: #030229">
          <span style="display: block; font-size: 14px;">{{$t('top_up.important_tip')}}：</span>
          <span style="display: block; margin-top: 8px; font-size: 14px;">{{ $t('top_up.payment_public', {method: method}) }}</span>
          <span style="display: block; margin-top: 8px; font-size: 14px; line-height: 30px;">2. <span style="color: #DC4D4D; margin-left: 5px;">{{$t('top_up.please_recharge_amount')}}</span>{{ $t('top_up.system_cannot') }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="close-color" style="width: 20%; margin-top: 30px; border: 1px #EFEFFF solid; border-radius: 10px;background: unset"  @click="cancel">{{$t('detail_param.close')}}</el-button>
        <el-button type="primary" style="background: linear-gradient(131.47deg, #FC5D9F -37.41%, #5863FC 111.11%);  margin-top: 30px; border-radius: 10px; margin-left: 20px;margin-right: 10px"  @click="cancel">{{$t('member.user_already_top_up')}}</el-button>
      </span>
    </el-dialog>





<!--    <el-dialog-->
<!--        :visible.sync="topUpDialogVisible"-->
<!--        width="510px"-->
<!--        :title="$t('top_up.property_top_up')"-->
<!--        class="topUpDialog"-->
<!--        height="304px">-->
<!--      <div class="topUp">-->
<!--        <div class="topUp_top" style="margin-top: 10px">-->
<!--          <div><span style="display: inline-block;font-size: 14px;color: #1E2329;vertical-align: middle;">充值账户</span>-->
<!--            <tooltip content="一旦我们收到您充值的资产，会自动上账到您所选择的账户。" style="display:inline-block;vertical-align: middle;margin-top: 1px"></tooltip>-->
<!--          </div>-->
<!--          <el-select style="display:block;position: relative;margin-top: 5px" disabled v-model="topUpInfo.rechargeTarget" name="">-->
<!--            <el-option value="1" label="资金账户"></el-option>-->
<!--            <el-option value="2" label="交易账户（燃料费）"></el-option>-->
<!--          </el-select>-->
<!--        </div>-->
<!--        <div class="topUp_top" style="margin-top: 15px">-->
<!--          <span style="display:block;width: 15%;color: #1E2329">{{$t('top_up.main_net')}}</span>-->
<!--          <div style="display: inline-block; width: 100%;margin-top: 5px"><el-input disabled placeholder="TRC20"></el-input></div>-->
<!--        </div>-->
<!--        <div>{{$t('top_up.wallet_address')}}</div>-->
<!--        <div><img :src="topUpInfo.qrCode" alt="" style="max-width: 130px"></div>-->
<!--        <div>-->
<!--          <span>{{topUpInfo.base58Address}}</span><img @click="handleCopyAddress" style="cursor: pointer" src="../../assets/img/rebate/copy.svg" alt="">-->
<!--        </div>-->
<!--        <div>{{$t('top_up.important_tip')}}</div>-->
<!--        <div>-->
<!--          <ul>-->
<!--&lt;!&ndash;            <li>{{$t('top_up.least_top_up_money')}} 50USDT</li>&ndash;&gt;-->
<!--            <li style="color:red;">{{$t('top_up.top_up_tip1')}}</li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </div>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <el-button type="primary" style="width: 100%"  @click="topUpDialogVisible=false">{{$t('top_up.confirm')}}</el-button>-->
<!--      </span>-->
<!--    </el-dialog>-->
  </div>
</template>

<script>
import axios from "axios";
import {getUserAddress, getUserAddressQrCode, setRechargeAccount, applyRecharge, getRechargeQrCode,getPaymentMethodsList} from "../../server/property";
import qr from '../../assets/js/qrcode.min'
import Tooltip from "../common/tooltip";

export default {
  name: "top_up",
  components: {Tooltip},
  data(){
    return{
      topUpTipDialogVisible:false,
      topUpDialogVisible:false,
      toRechargeDialog: false,
      topUpInfo:{
        base58Address:'',
        qrCode:'',
        rechargeTarget: '1',
      },
      rechargeAmount: '',
      methodList: [],
      qrCodeUrl: '',
      address: '',
      timeOut: '',
      confirmMoney: '',

	  current:'',
	  payType:1,
	  method: '',
    selectedMethod:null
    }
  },
  props:['userInfo'],
  
   created() {
   	this.getPaymentMethodsList()
   },

  methods:{
	  getPaymentMethodsList(){
		  getPaymentMethodsList().then(res => {
			  if(!res) return
			  if(res.data){
				  this.methodList = res.data;
          if(this.methodList.length > 0){
            const first = this.methodList[0];
            this.current = first.chain_detail;
            this.payType = first.type;
            this.method = first.chain_detail;
    
          }
				
			  }
		  })
	  },
	  
    toRecharge() {
      console.log('qweqweqweqwe', this.rechargeAmount)
      if (!this.rechargeAmount) {
        this.$message.warning(this.$t('top_up.please_enter_recharge_amount'))
        return
      }
	  
      this.setQrcode()
      this.toRechargeDialog = true
    },

    handleClickTip(){
      // this.topUpTipDialogVisible=false
      this.topUpDialogVisible=true
      axios.post(`https://houtai.felton.fit/fqwallet/api/tron-usdt/user-address?userId=${this.userInfo.id}`).then(res=>{
        if (res.data.statusCode!==200) return this.$message.error(this.$t('top_up.get_tip'))
        this.topUpInfo.base58Address=res.data.data.base58Address
        this.topUpInfo.qrCode='https://houtai.felton.fit/wallet/qrcode/'+res.data.data.qrCode
      })
    },
    getTopUpInfo(info){
       console.log('info', info);
      // this.topUpTipDialogVisible=true
      // this.handleClickTip()
      if (info) {
        this.confirmMoney = info.chongzhi_money
        this.address = info.chongzhi_url
        this.timeOut = info.deleted_at;
		this.method = info.main_chain_detail.slice(info.main_chain_detail.indexOf('(') + 1, info.main_chain_detail.indexOf(')'));
        this.getRechargeQrCode(info.uid)
        this.toRechargeDialog = true;

      } else {
        this.getUserAddress()
      }
    },

    handleCopyAddress(){
      const input = document.createElement('input');
      document.body.appendChild(input);
      input.setAttribute('value', this.topUpInfo.base58Address);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success(this.$t('top_up.copy_success'))
      }
      document.body.removeChild(input);
    },

    getUserAddress(){
        this.getUserAddressQrCode()
    },
    async getUserAddressQrCode(){
      this.topUpDialogVisible = true
    },
    async copyText(address) {
      try {
        await navigator.clipboard.writeText(address);
        this.$message.success(this.$t('top_up.copy_success'))
      } catch (err) {
        console.error('复制失败', err);
      }
    },
    setQrcode() {
      applyRecharge(this.rechargeAmount, this.payType).then(res=>{
        if (!res) return
        if(res.success) {
          this.topUpDialogVisible = false
          this.address = res.data.address
          this.timeOut = res.data.time
          this.confirmMoney = res.data.money
		  var data = res.data.addressInfo
		  if(data.chain_detail.indexOf('(') && data.chain_detail.indexOf(')')){
			  const start = data.chain_detail.indexOf('(') + 1;
			  const end = data.chain_detail.indexOf(')')
			  this.method = data.chain_detail.slice(start,end)
		  }
          this.getRechargeQrCode()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getRechargeQrCode(uid){
      getRechargeQrCode(uid).then(res=>{
        if (!res) return
        this.qrCodeUrl = window.URL.createObjectURL(res)
      })
    },


  handleMethodChange(value){
   const selectedItem = this.methodList.find(item => item.chain_detail === value);
   if(selectedItem){
    this.payType = selectedItem.type;
    this.method = selectedItem.chain_detail;
   }
  },

	btnCancel(){
		this.rechargeAmount = '';
		this.resetPaymentMethod();
    this.topUpDialogVisible = false
	},
	checkInput(val){
		let num = val.replace(/[^\d]/g, '');
		if (num.length > 1) {
		  num = num.replace(/^0+/, ''); // 去掉前导零
		}
		this.rechargeAmount = num;
		
	},
	cancel(){
		this.toRechargeDialog = false;
		this.rechargeAmount = '';
		this.resetPaymentMethod()
		
	},
	resetPaymentMethod() {
		if(this.methodList.length > 0){
			this.current = this.methodList[0].chain_detail;
			this.payType = this.methodList[0].type;

		}
	}
  }
}
</script>

<style scoped>
.uni-select {
	position: relative;
	box-sizing: border-box;
	width: 200px;
}
.uni-select__selector {
	position: absolute;
	width: 100%;
	top:30px;
	
}

/*充值的对话框*/
/deep/ .topUpDialog .el-dialog__body {
  padding:15px 26px !important;
}
.topUp>div:first-child{
  font-size: 12px;
  color: #72777E;
}
.topUp>div:nth-child(2){
  margin: 8px 0 24px 0px;
}
.topUp>div:nth-child(3){
  font-size: 12px;
  color: #72777E;
}
.topUp>div:nth-child(4) img{
  width: 136px;
  height: 136px;
  display: inline-block;
  margin: 8px 0 16px 0;
}
.topUp>div:nth-child(5){
  padding: 11px 0 24px 0;
  border-top: 1px solid #EAECEF;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.topUp>div:nth-child(5)>span{
  font-size: 12px;
  color: #1E2329;
}
.topUp>div:nth-child(5)>img{
  display: inline-block;
}
.topUp>div:nth-child(6){
  font-size: 12px;
  color: #72777E;
}
.topUp>div:nth-child(7)>ul{
  margin: 8px 0 0 0 ;
  padding-left: 20px;
}
.topUp>div:nth-child(7)>ul>li{
  font-size: 14px;
  color: #1E2329;
  line-height: 25px;
}
.topUp>div:nth-child(7)>ul>li:nth-child(2){
  color:red;
}

@media screen  and (max-width: 900px){
  .topUp>div:nth-child(4) img{
    width: 100px;
    height: 100px;
    margin: 8px 0 8px 0;
  }
  .topUp>div:nth-child(5){
    padding: 10px 0 11px 0;
  }
  /deep/ .topUpDialog .el-dialog__body {
    padding:5px 20px !important;
  }
  /deep/ .topUpDialog .el-form-item {
    margin-bottom: 8px;
  }
}

 >>> .topUpTipDialog >div{
   background: linear-gradient(180deg, #E2ECFF 0%, #FFFFFF 100%);
}
>>> .topUpTipDialog .el-dialog__header{
  padding: 0;
}

.input_money {
  display: inline-block;
  font-size: 16px;
  width: 84%;
  font-weight: 600;
}

.input_money >>>.el-input__inner {
  border: unset;
  background: #F7F7F8;
}

.input_money >>>.el-input__inner::placeholder {
  font-size: 14px;
  font-weight: 400;
}

.chongzhi >>>.el-dialog {
  border-radius: 10px;
  padding-bottom: 30px;
}

.chongzhi >>>.el-dialog__header {
  padding-top: 50px;
  padding-left: 30px;
}

.chongzhi >>>.el-dialog__title{
  font-size: 20px !important;
  font-weight: 600;
}

.chongzhi >>>.el-dialog__headerbtn {
  background: #F9F7FD;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  line-height: 43px;
  text-align: center;
  margin-top: 20px;
  margin-right: 10px;
}

.chongzhi >>>.el-dialog__close {
  color: transparent !important;
  background-image: linear-gradient(131.47deg, #FC5D9F -37.41%, #5863FC 111.11%);
  background-clip: text;
  -webkit-background-clip: text;
  font-size: 20px;
  vertical-align: middle;
  padding: 0;
  line-height: unset;
  display: inline-block;
  margin-top: -2px;
}

.close-color{
  color: #AB54DB
}

</style>
